import React, { ReactNode, ElementType, MouseEventHandler } from 'react'
import { Link } from 'react-router-dom'
import { TableRow as MUITableRow, SxProps } from '@mui/material'

export interface TableRowProps {
  children?: ReactNode
  component?: ElementType<any>
  hover?: boolean
  href?: string
  lastRowHasBorder?: boolean
  noBorder?: boolean
  search?: string
  selected?: boolean
  sx?: SxProps
  onClick?: MouseEventHandler<HTMLTableRowElement>
  onMouseDown?: MouseEventHandler<HTMLTableRowElement>
}

const TableRow = React.forwardRef((props: TableRowProps, ref: any) => {
  const {
    children,
    href,
    lastRowHasBorder,
    noBorder,
    onClick,
    search,
    sx,
    ...rest
  } = props

  const noBorderSx = { '& > *': { borderBottom: 'unset!important' } }
  const hasBorderSx = {
    '& td': { borderBottom: 1, borderColor: 'divider' },
    '& th': { borderBottom: 1, borderColor: 'divider' },
    '&:last-child td, &:not(:only-child) th': lastRowHasBorder
      ? { borderBottom: 1, borderColor: 'divider' }
      : { borderBottom: 0 }
  }

  const borderSx = noBorder ? noBorderSx : hasBorderSx

  return (
    <MUITableRow
      {...rest}
      {...(href || search
        ? {
            component: Link,
            to: search
              ? {
                  pathname: href,
                  search
                }
              : href
          }
        : null)}
      onClick={onClick}
      ref={ref}
      sx={{
        ...borderSx,
        ...(onClick || href ? { cursor: 'pointer' } : null),
        ...sx
      }}
    >
      {children}
    </MUITableRow>
  )
})

TableRow.displayName = 'TableRow'
export default TableRow
